import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Icon from 'components/_new/ui/Icon/Icon'
import CircleLoader from 'components/loaders/CircleLoader/CircleLoader'

import s from './SelectableBoxView.scss'


const iconNames = {
  plus: 'plusInCircle',
  checkmark: 'checkmarkInCircle',
}

const SelectableBoxView = (props) => {
  const {
    children, className, tag,
    icon, iconColor, iconPosition,
    withBg, fullWidth, active,
    isFetching, onClick,
  } = props

  const iconClassName = cx(s.icon, s[iconPosition], {
    [s.circleLoader]: isFetching,
  })
  const iconName      = icon && iconNames[icon]

  const rootClassName = cx(s.selectableBox, className, {
    [s.withBg]: withBg,
    [s.fullWidth]: fullWidth,
    [s.active]: active,
  })

  const iconNode = Boolean(iconName) && (
    isFetching
      ? <CircleLoader className={iconClassName} />
      : <Icon className={iconClassName} name={iconName} color={iconColor} />
  )

  return React.createElement(
    tag,
    {
      className: rootClassName,
      onClick,
    },
    iconNode,
    children,
  )
}

SelectableBoxView.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.oneOf([ 'plus', 'checkmark' ]),
  iconColor: PropTypes.oneOf([ 'brand', 'black' ]),
  iconPosition: PropTypes.oneOf([ 'topLeft', 'rightCenter' ]),
  withBg: PropTypes.bool,
  fullWidth: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func,
}

SelectableBoxView.defaultProps = {
  tag: 'button',
  iconPosition: 'topLeft',
  withBg: true,
}


export default SelectableBoxView
